import { API_BASE_URL } from '../lib/config';

// Get token from store
const getToken = () => {
    const stored = localStorage.getItem('admin-storage');
    if (stored) {
        const parsed = JSON.parse(stored);
        return parsed.state?.token;
    }
    return null;
};

// API client with auth headers
const apiClient = async (endpoint: string, options: RequestInit = {}) => {
    const token = getToken();

    const headers: Record<string, string> = {
        'Content-Type': 'application/json',
        ...(options.headers as Record<string, string>),
    };

    if (token) {
        headers['Authorization'] = `Bearer ${token}`;
    }

    const response = await fetch(`${API_BASE_URL}${endpoint}`, {
        ...options,
        headers,
    });

    if (!response.ok) {
        throw new Error(`API Error: ${response.statusText}`);
    }

    return response.json();
};

export const adminApi = {
    // Auth
    login: async (password: string) => {
        return fetch(`${API_BASE_URL}/auth/login`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ password }),
        }).then(res => res.json());
    },

    // Stats
    getStats: async () => {
        return apiClient('/admin/stats');
    },

    // Orders
    getOrders: async (filters?: any) => {
        const params = new URLSearchParams(filters).toString();
        return apiClient(`/orders${params ? `?${params}` : ''}`);
    },

    getOrder: async (id: string) => {
        return apiClient(`/orders/${id}`);
    },

    updateOrderStatus: async (id: string, status: string) => {
        return apiClient(`/orders/${id}/status`, {
            method: 'PATCH',
            body: JSON.stringify({ status }),
        });
    },

    // Transactions (mock for now)
    getTransactions: async (_filters?: any) => {
        // TODO: Implement when backend endpoint is ready
        return Promise.resolve([]);
    },

    // Wallets (mock for now)
    getWallets: async () => {
        // TODO: Implement when backend endpoint is ready
        return Promise.resolve([]);
    },
};
